import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
export const constantRoutes = [
  {
    path: "/",
    redirect: "/index",
    component: () => import("@/pages/layout/index.vue"),
    children: [
      {
        path: "/index",
        name: "home",
        component: () => import("@/pages/home/index.vue"),
      },
      {
        path: "/cookies",
        name: "cookies",
        component: () => import("@/pages/cookies/index.vue"),
      },
      {
        path: "/privacy",
        name: "privacy",
        component: () => import("@/pages/privacy/index.vue"),
      },
      {
        path: "/product",
        name: "product",
        component: () => import("@/pages/product/list.vue"),
      },
      {
        path: "/detail",
        name: "Detail",
        component: () => import("@/pages/product/detail.vue"),
      },
      {
        path: "/Wohannlage",
        name: "Wohannlage",
        component: () => import("@/pages/solution/index.vue"),
      },
      {
        path: "/Company",
        name: "Company",
        component: () => import("@/pages/solution/company.vue"),
      },
      {
        path: "/Top",
        name: "Top",
        component: () => import("@/pages/solution/top.vue"),
      },
      {
        path: "/Tung",
        name: "Tung",
        component: () => import("@/pages/transformator/top.vue"),
      },
      // Comny
      {
        path: "/Industriell",
        name: "Industriell",
        component: () => import("@/pages/solution/index.vue"),
      },
      {
        path: "/Konfigurator",
        name: "Konfigurator",
        component: () => import("@/pages/solution/Konfigurator.vue"),
      },
      {
        path: "/cart",
        name: "cart",
        component: () => import("@/pages/cart/index.vue"),
      },
      {
        path: "/pay",
        name: "Pay",
        component: () => import("@/pages/pay/index.vue"),
      },      {
        path: "/pay2",
        name: "Pay2",
        component: () => import("@/pages/pay/index copy.vue"),
      },
      {
        path: "/payResult",
        name: "payResult",
        component: () => import("@/pages/pay/result.vue"),
      },
      {
        path: "/payFail",
        name: "payFail",
        component: () => import("@/pages/pay/fail.vue"),
      },
      {
        path: "/payCancle",
        name: "payCancle",
        component: () => import("@/pages/pay/cancle.vue"),
      },
      {
        path: "/404",
        component: () => import("@/pages/error/404.vue"),
      },
      {
        path: "/Kontakt",
        name: "Kontakt",
        component: () => import("@/pages/contact/index.vue"),
      },
      {
        path: "/ord",
        name: "Ord",
        component: () => import("@/pages/order/index.vue"),
      },
      {
        path: "/address",
        name: "address",
        component: () => import("@/pages/address/index.vue"),
      },{
        path: "/news",
        name: "news",
        component: () => import("@/pages/news/list.vue"),
      },{
        path: "/newDetail",
        name: "newdetail",
        component: () => import("@/pages/news/detail.vue"),
      },{
        path: "/power",
        name: "Power",
        component: () => import("@/pages/power/index.vue"),
      },{
        path: "/power/detail/:id?",
        name: "PowerDetail",
        component: () => import("@/pages/power/detail.vue"),
      },{
        path: "/Comny",
        name: "Comny",
        component: () => import("@/pages/power/index2.vue"),
      },     {
        path: "/Mitt",
        name: "mitt",
        component: () => import("@/pages/power/index3.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login/index.vue"),
  },
  {
    path: "/resetPwd",
    name: "resetPwd",
    component: () => import("@/pages/login/resetPassword.vue"),
  },
];
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
const router = new Router({
  mode: "history",
  // base: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});

router.afterEach((to, from) => {
  if (to.name !== 'Detail') {
    let title = 'OSS Energie';
    if (to.name) {
      title = `${to.name} - OSS Energie Europa`;
    }
    document.title = title;
  }
});

export default router;
